import * as Yup from "yup";

export const stockTransferSchema = Yup.object().shape({
  stock_selected: Yup.object()
    .nullable()
    .required("Por favor, selecione o estoque."),
});
